module.exports = __webpack_public_path__ + "media/v2/icon_link-96ed5421.svg";